export default __webpack_public_path__ + "static/ventilator_w.843a1608936036ba641736c0ca1a9016.svg";